var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { TableContainer, Box } from '@mui/material';
import styled from '@mui/material/styles/styled';
import Table from './src/Table';
import Thead from './src/Thead';
import Tbody from './src/Tbody';
import Loading from './src/Loading';
import Pagination from './src/Pagination';
var Root = styled(Box)({
    position: 'relative',
    overflow: 'hidden'
});
var FbmTable = function (_a) {
    var loading = _a.loading, data = _a.data, emptyText = _a.emptyText, emptyUrl = _a.emptyUrl, columns = _a.columns, batchActions = _a.batchActions, nameText = _a.nameText, PaginationProps = _a.PaginationProps, TableContainerProps = _a.TableContainerProps, onRowClick = _a.onRowClick;
    return (React.createElement(Root, null,
        React.createElement(Loading, { loading: loading, nameText: nameText }),
        React.createElement(TableContainer, __assign({}, TableContainerProps),
            React.createElement(Table, null,
                React.createElement(Thead, { data: data, nameText: nameText, columns: columns, batchActions: batchActions }),
                React.createElement(Tbody, { data: data, columns: columns, emptyText: emptyText, emptyUrl: emptyUrl, loading: loading, onRowClick: onRowClick }))),
        React.createElement(Pagination, __assign({}, PaginationProps))));
};
FbmTable.defaultProps = {
    align: 'left',
    columns: [],
    PaginationProps: {
        total: 0
    },
    TableContainerProps: {},
};
export default FbmTable;
